module.exports = __webpack_public_path__ + "static/media/albaraka_api2.ae8d1b6b.png";